import { IState } from '../../store';
import { IAgent } from '../../types/offerData';

export function selectOfferAgent(state: IState): IAgent | null {
  return state.offerData.agent;
}
